  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Sync Type</mat-label>
    <mat-select 
      [value]="currentSyncType" 
      [disabled]="disabled || isLoadingSync"
      (selectionChange)="onSyncTypeChange($event.value)"
      class="sync-dropdown"
    >
      <mat-option [value]="ESyncType.FullSync">
        <div class="flex flex-col">
          <span class="font-medium">Full Sync</span>
          <span class="text-sm text-gray-600"> - Sync all data including athletes and results</span>
        </div>
      </mat-option>
      <mat-option [value]="ESyncType.SensitiveSync">
        <div class="flex flex-col">
          <span class="font-medium">Sensitive Sync</span>
          <span class="text-sm text-gray-600"> - Sync everything except athletes and results</span>
        </div>
      </mat-option>
      <mat-option [value]="ESyncType.NoSync">
        <div class="flex flex-col">
          <span class="font-medium">No Sync</span>
          <span class="text-sm text-gray-600"> - No data will be sent to server</span>
        </div>
      </mat-option>
    </mat-select>
    <mat-spinner *ngIf="isLoadingSync" diameter="20" class="mr-2"></mat-spinner>
  </mat-form-field>
